import Axios from 'axios';

export default {
  getStudentContracts(billingIds) {
    return Axios.get('/admin/contracts', {
      params: {
        billing_ids: billingIds,
      },
    })
      .then(({ data }) => data);
  },

  cancelContract(contractId, observations) {
    return Axios.put(`/admin/contracts/${contractId}/cancel`, { observations })
      .then(({ data }) => data);
  },

  updateContractBillsDueDate(contractId, day) {
    return Axios.put(`/admin/contracts/${contractId}/update-bills-due-date`, { day })
      .then(({ data }) => data);
  },

  changeContractValue(contractId, params) {
    return Axios.put(`/admin/contracts/${contractId}/update-contract-value`, params)
      .then(({ data }) => data);
  },

  createContract(params) {
    return Axios.post('admin/contracts', params)
      .then(({ data }) => data);
  },
};
